import { Component, OnInit } from "@angular/core";
import { OwlOptions } from "ngx-owl-carousel-o";
import { StaticPageGetByPageKeyOutputDTO } from "src/app/models/contents.models/staticPage.models/staticPageGetByPageKeyOutputDTO.model";
import { StaticPagesSiteService } from "src/app/services/staticPagesSite.service";
import { DResult } from "src/app/models/common.models/dresult.model";
import { API_ServerAddress } from "src/app/MyAppCommonConfig";
import { ProductsSiteService } from "src/app/services/productsSite.service";
import { ProductGetListByProductTypeIdOutputDTO } from "src/app/models/products.models/product.models/productGetListByProductTypeIdOutputDTO.model";
import { VideoGetListOutputDTO } from "src/app/models/contents.models/Video.models/VideoGetListOutputDTO.model";
import { VideosSiteService } from "src/app/services/videosSite.service";
import { ArticlesSiteService } from "src/app/services/articlesSite.service";
import { BlogsSiteService } from "src/app/services/blogsSiteService";
import { ArticleGetListOutputDTO } from "src/app/models/contents.models/article.models/articleGetListOutputDTO.model";
import { BlogGetListOutputDTO } from "src/app/models/contents.models/Blog.models/BlogGetListOutputDTO.model";
import { ColleaguesSiteService } from "src/app/services/colleaguesSite.service";
import { ColleagueGetListOutputDTO } from "src/app/models/informations.models/colleague.models/colleagueGetListOutputDTO.model";
import { SiteSEOHelperService } from "src/app/services/siteseoHelper.service";

@Component({
  selector: "home",
  templateUrl: "home.component.html"
})
export class HomeComponent implements OnInit {
  ngOnInit(): void {
    this.GetCommonPage();
    this.GetTopHardwares();
    this.GetTopSoftwares();
    this.GetTopVideos();
    this.GetTopArticles();
    this.GetTopBlogs();
    this.GetTopColleagues();
  }

  APIServerAddress: string = API_ServerAddress;
  pageKey: string = "HomeIndex";
  commonPage: StaticPageGetByPageKeyOutputDTO = new StaticPageGetByPageKeyOutputDTO();
  slideShow1: string = "#";
  slideShow2: string = "#";
  slideShow3: string = "#";
  topHardwares: ProductGetListByProductTypeIdOutputDTO[] = [];
  topSoftwares: ProductGetListByProductTypeIdOutputDTO[] = [];
  firstTopVideo: VideoGetListOutputDTO = new VideoGetListOutputDTO();
  topVideos: VideoGetListOutputDTO[] = [];
  topArticles: ArticleGetListOutputDTO[] = [];
  topBlogs: BlogGetListOutputDTO[] = [];
  topColleagues: ColleagueGetListOutputDTO[] = [];

  constructor(
    private siteSEOHelperService: SiteSEOHelperService,
    private staticPagesSiteService: StaticPagesSiteService,
    private productsSiteService: ProductsSiteService,
    private videosSiteService: VideosSiteService,
    private articlesSiteService: ArticlesSiteService,
    private blogsSiteService: BlogsSiteService,
    private colleaguesSiteService: ColleaguesSiteService
  ) {}

  GetCommonPage() {
    this.staticPagesSiteService
      .GetByPageKey(this.pageKey)
      .subscribe((data: DResult<StaticPageGetByPageKeyOutputDTO>) => {
        if (data.isSuccess) {
          this.commonPage = data.result;
          this.slideShow1 =
            this.APIServerAddress + this.commonPage.slideShowImageAddress1;
          this.slideShow2 =
            this.APIServerAddress + this.commonPage.slideShowImageAddress2;
          this.slideShow3 =
            this.APIServerAddress + this.commonPage.slideShowImageAddress3;

          this.siteSEOHelperService.SetPageMetaData(
            this.commonPage.metaTitle,
            this.commonPage.metaDescription,
            this.commonPage.metaKeywords
          );
        }
      });
  }

  GetTopHardwares() {
    this.productsSiteService
      .GetTopByProductTypeId(6, 1)
      .subscribe((data: DResult<ProductGetListByProductTypeIdOutputDTO[]>) => {
        if (data.isSuccess) {
          this.topHardwares = data.result;
        }
      });
  }

  GetTopSoftwares() {
    this.productsSiteService
      .GetTopByProductTypeId(4, 2)
      .subscribe((data: DResult<ProductGetListByProductTypeIdOutputDTO[]>) => {
        if (data.isSuccess) {
          this.topSoftwares = data.result;
        }
      });
  }

  GetTopVideos() {
    this.videosSiteService
      .GetTop(4)
      .subscribe((data: DResult<VideoGetListOutputDTO[]>) => {
        if (data.isSuccess && data.result.length > 0) {
          this.firstTopVideo = data.result[0];
          this.topVideos = data.result.slice(1, data.result.length);
        }
      });
  }

  GetTopArticles() {
    this.articlesSiteService
      .GetTop(4)
      .subscribe((data: DResult<ArticleGetListOutputDTO[]>) => {
        if (data.isSuccess) {
          this.topArticles = data.result;
        }
      });
  }

  GetTopBlogs() {
    this.blogsSiteService
      .GetTop(4)
      .subscribe((data: DResult<BlogGetListOutputDTO[]>) => {
        if (data.isSuccess) {
          this.topBlogs = data.result;
        }
      });
  }

  GetTopColleagues() {
    this.colleaguesSiteService
      .GetList()
      .subscribe((data: DResult<ColleagueGetListOutputDTO[]>) => {
        if (data.isSuccess) {
          this.topColleagues = data.result.sort((a, b) => a.showPriority < b.showPriority ? -1 : a.showPriority > b.showPriority ? 1 : 0);
        }
      });
  }

  MakeShortDescription(input: string, maxChar: number) {
    if (input.length <= maxChar) {
      return input;
    } else {
      return input.substring(0, maxChar) + " . . . ";
    }
  }

  mainSliderOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    navSpeed: 700,
    navText: ["", ""],
    responsive: {
      0: {
        items: 1
      }
    },
    nav: true,

    //Important !!
    autoplay: true,
    //Important for rtl page !!
    rtl: true
  };

  colleaguesSliderOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    navSpeed: 700,
    navText: ["", ""],
    responsive: {
      0: {
        items: 1
      },
      600: {
        items: 2
      },
      1000: {
        items: 4
      }
    },
    nav: true,

    //Important !!
    autoplay: true,
    //Important for rtl page !!
    rtl: true,

    margin: 10
  };
}
